module.exports = "/packs/media/images/hotairballoons-86c88cd290bd5770a4adf08488a8417e.jpeg";